<template>
    <div class="coming-soon pt-16">
        <div v-if="currentRoute === 'AdminDashboard'">
            <div class="text-h4 coming-soon-title text-center font-weight-bold"
                style="letter-spacing: 0.7rem!important;">Dashboard Is coming on<br />
                </div>
        </div>
        <div v-else class="text-h4 coming-soon-title text-center font-weight-bold"
            style="letter-spacing: 0.7rem!important;" v-html="message"></div>
    </div>
</template>
<script>

export default {
    props: {
        message: {
            type: String,
            default: 'Feed Management is coming soon'
        }
    },
    computed: {
        currentRoute() {
            return this.$route.name;
        }
    }

}
</script>

<style scopped>
.coming-soon {
    background: url('/img/coming-soon-new.svg') no-repeat center center;
    border-radius: 10px;
    height: 100vh;
}

.coming-soon-title {
    font-family: 'Poppins';
    /* font-style: normal;
    font-weight: 500;
    font-size: 64px;
    line-height: 20px;
    color: #000000; */

}
</style>